import { useEffect, useState } from 'react';

/**
 * O ambiente em que a tela do Brain original se ajusta: largura (celular a 600
 * px, telefone pequeno a 480), toque sem mouse e a fonte que o original carregava.
 */

/** `useMediaQuery` do original. Sem `matchMedia` (jsdom), responde `false`. */
export function useConsultaDeMidia(consulta: string): boolean {
    const ler = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(consulta).matches;
    const [casa, setCasa] = useState(ler);
    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        const mq = window.matchMedia(consulta);
        const aoMudar = (e: MediaQueryListEvent) => setCasa(e.matches);
        setCasa(mq.matches);
        mq.addEventListener('change', aoMudar);
        return () => mq.removeEventListener('change', aoMudar);
    }, [consulta]);
    return casa;
}

const ID_DA_FONTE = 'brain-fonte-inter';

/**
 * O original carregava Inter do Google Fonts no `index.html`; aqui a folha só
 * entra quando o Brain abre, para não pesar o resto do VecchIA. A pilha de
 * fontes do CSS (`--brain-font`) começa pelas do sistema e cai em Inter.
 */
export function carregarFonteDoBrain(): void {
    if (typeof document === 'undefined' || document.getElementById(ID_DA_FONTE)) return;
    const link = document.createElement('link');
    link.id = ID_DA_FONTE;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';
    document.head.appendChild(link);
}
